/**
 * --------------------------------------------------------------------------
 * CoreUI PRO data-grid ui/loading.ts
 * License (https://coreui.io/pro/license/)
 * --------------------------------------------------------------------------
 */

import type { DataGridLabels } from '../types'

const CLASS_NAME_LOADING = 'data-grid-loading'

export interface GridLoading {
  element: HTMLDivElement
  setVisible: (visible: boolean) => void
}

export const createLoading = (labels: DataGridLabels, className = CLASS_NAME_LOADING): GridLoading => {
  const element = document.createElement('div')
  element.classList.add(className)
  element.hidden = true

  const spinner = document.createElement('div')
  spinner.classList.add('spinner-border')
  spinner.setAttribute('role', 'status')

  const label = document.createElement('span')
  label.classList.add('visually-hidden')
  label.textContent = labels.loading
  spinner.append(label)

  element.append(spinner)

  return {
    element,
    setVisible(visible) {
      element.hidden = !visible
    }
  }
}
